import AuthorizeLogin from './AuthorizeLogin'
export { AuthorizeLogin }
export default AuthorizeLogin
